import React from 'react';

import { IconButton, Tooltip } from '@material-ui/core';
import { StarOutline, ArrowRight, ArrowLeft } from '@material-ui/icons';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import file from '../../../assets/excelFile.svg'
import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import { AnalyDetail } from '../../../models/Analytics';


const NextArrow = (props: any) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
      aria-label="Next"
      onClick={onClick}
      className={newClass}
      classes={{ root: styles.tsrightArrow }}
    >
      <ArrowRight
        color="primary" className={`${styles.tsrightArrowIcon}`}
      />
    </IconButton>
  );
};

const PrevArrow = (props: any) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
      aria-label="Prev"
      onClick={onClick}
      className={newClass}
      classes={{ root: styles.tsleftArrow }}
    >
      <ArrowLeft
        color="primary" className={`${styles.tsleftArrowIcon}`}
      />
    </IconButton>
  );
};

const settings = {
  infinite: false,
  dots: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ]
};

interface TopScreenersProps {
  screeners: AnalyDetail[];
  report: string;
  handleExport: (type: string) => void;
};

const TopScreeners = (props: TopScreenersProps) => {
  let i = 1;
  const getTopScreeners: Array<JSX.Element> = props.screeners.map((item: AnalyDetail) => {
    return (
      <div className={`${styles.tsWrapper}`}>
        <div className={`${styles.topScreener}`}>
          <span className={`${styles.tsStarWrapper}`}>
            <StarOutline
              classes={{
                root: styles.tsStar
              }}
            />
            <span className={`${styles.tsNo}`}>{i++}</span>
          </span>
          <Tooltip title={item.name}><small className={`${styles.tsName}`}>{item.name}</small></Tooltip>
        </div>
        <div className={`${styles.tsDataWrapper} ${commonStyles.fMiddle} ${commonStyles.fColumn}`}>
          <p className={styles.tsData}><b>{props.report == 'wgt' ? Math.round(item.wgt) : (props.report == 'pcs' ? item.pcs : item.awbs)}</b></p>
          <p className={styles.tsDataUnit}>{props.report == 'wgt' ? 'KILOS' : (props.report == 'pcs' ? 'PIECES' : 'AWBS')}</p>
        </div>
      </div>
    )
  })
  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={commonStyles.fSpaceBtw}>
        <h5 className={styles.heading}> Top Screeners</h5>
        <div className={`${styles.fileImg}`} onClick={() => props.handleExport('screeners')}>
          <img src={file} alt="file" />
        </div>
      </div>
      <div>
        <Slider {...settings} className={`${styles.tcslider}`}>
          {getTopScreeners}
        </Slider>
      </div>
    </div>
  );
};

export default TopScreeners;